//https://editor.method.ac/
import React from 'react';

class EraserSvg extends React.Component {
	render() {
    return (
      	<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" clipRule="evenodd">
		 <g>
		  <g stroke="null" id="svg_9">
		   <g stroke="null" transform="matrix(0.036446606778175225,0,0,0.03901740680829846,0.8539441356304351,0) " id="svg_5">
		    <metadata stroke="null" transform="translate(-12.440990447998047,0) translate(0,-12.449631690979004) " id="svg_6"/>
		    <path stroke="null" id="svg_8" d="m131.64301,525.49037l169.219,0l47.41,-47.2801c7.31111,-7.2993 7.32292,-19.264 0.03543,-26.5633l-140.742,-141.132c-7.28749,-7.31111 -19.2522,-7.32292 -26.5633,-0.03543l-118.962,118.631c-7.32292,7.2993 -7.32292,19.2522 -0.03543,26.5633l69.6387,69.8158l-0.0004,0.00073zm225.8774,-0.00073l270.039,0l0,51.2841l-321.453,0l-56.6464,0l-66.674,0l-61.3826,0l-1.80711,0l-126.58,-126.911c-7.2993,-7.31111 -7.28749,-19.2758 0.03543,-26.5633l380.497,-379.493c7.33474,-7.31111 19.2758,-7.28749 26.5751,0.03543l206.341,206.884c7.28749,7.2993 7.27568,19.264 -0.04724,26.5633l-248.897,248.2l-0.00018,0.00047z" fill="black"/>
		   </g>
		  </g>
		 </g>
		</svg>      
    );
  }
}

export default EraserSvg;


// WEBPACK FOOTER //
// ./src/containers/components/svg/EraserSvg.js